/* Generated by scripts/generate-bravos-icons.mjs — Lucide-compatible trainer icons. */
import React from 'react';
import { BRAVOS_GLYPHS } from '../../icons/bravosGlyphs';

function bravosSvg(iconId: string) {
  const glyph = BRAVOS_GLYPHS[iconId];
  if (!glyph) {
    const Missing: React.FC<React.SVGProps<SVGSVGElement>> = () => null;
    return Missing;
  }
  type IconProps = React.SVGProps<SVGSVGElement> & {
    size?: number;
    strokeWidth?: number | string;
  };
  const Icon: React.FC<IconProps> = ({
    className,
    size,
    width,
    height,
    color,
    strokeWidth: _strokeWidth,
    ...props
  }) => (
    <svg
      viewBox={glyph.viewBox}
      width={width ?? size ?? 24}
      height={height ?? size ?? 24}
      className={className}
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
      {...props}
      dangerouslySetInnerHTML={{ __html: glyph.body }}
    />
  );
  Icon.displayName = iconId;
  return Icon;
}

export const Activity = bravosSvg("mingcute:heartbeat-line");
export const AlertTriangle = bravosSvg("mingcute:warning-line");
export const ArrowDown = bravosSvg("mingcute:arrow-down-line");
export const ArrowLeftRight = bravosSvg("mingcute:transfer-horizontal-line");
export const ArrowRight = bravosSvg("mingcute:arrow-right-line");
export const ArrowUp = bravosSvg("mingcute:arrow-up-line");
export const ArrowUpDown = bravosSvg("mingcute:sort-ascending-line");
export const BookOpen = bravosSvg("mingcute:book-2-line");
export const Bookmark = bravosSvg("mingcute:bookmark-line");
export const Calendar = bravosSvg("mingcute:calendar-line");
export const CalendarDays = bravosSvg("mingcute:calendar-line");
export const Check = bravosSvg("mingcute:check-line");
export const CheckCircle = bravosSvg("mingcute:check-circle-line");
export const ChevronDown = bravosSvg("mingcute:down-line");
export const ChevronLeft = bravosSvg("mingcute:left-line");
export const ChevronRight = bravosSvg("mingcute:right-line");
export const ChevronUp = bravosSvg("mingcute:up-line");
export const Clock = bravosSvg("mingcute:time-line");
export const Copy = bravosSvg("mingcute:copy-2-line");
export const Dumbbell = bravosSvg("mingcute:barbell-line");
export const Edit = bravosSvg("mingcute:pencil-line");
export const ExternalLink = bravosSvg("mingcute:external-link-line");
export const Filter = bravosSvg("mingcute:filter-2-line");
export const Hourglass = bravosSvg("mingcute:sandglass-line");
export const Image = bravosSvg("mingcute:pic-line");
export const Info = bravosSvg("mingcute:information-line");
export const Library = bravosSvg("mingcute:book-2-line");
export const List = bravosSvg("mingcute:list-check-line");
export const LogOut = bravosSvg("mingcute:exit-line");
export const MessageCircle = bravosSvg("lucide:message-circle");
export const Minus = bravosSvg("mingcute:minimize-line");
export const MinusCircle = bravosSvg("mingcute:close-circle-line");
export const MoreVertical = bravosSvg("lucide:ellipsis-vertical");
export const Pause = bravosSvg("lucide:pause");
export const Pencil = bravosSvg("mingcute:pencil-line");
export const Pin = bravosSvg("mingcute:pin-line");
export const Play = bravosSvg("mingcute:play-line");
export const Plus = bravosSvg("mingcute:add-line");
export const RefreshCw = bravosSvg("mingcute:refresh-1-line");
export const Repeat = bravosSvg("mingcute:repeat-line");
export const RotateCcw = bravosSvg("mingcute:refresh-1-line");
export const Save = bravosSvg("mingcute:save-2-line");
export const Search = bravosSvg("mingcute:search-line");
export const Settings = bravosSvg("lucide:settings");
export const Star = bravosSvg("mingcute:star-line");
export const Target = bravosSvg("mingcute:target-line");
export const Trash2 = bravosSvg("mingcute:delete-2-line");
export const User = bravosSvg("mingcute:user-3-line");
export const UserPlus = bravosSvg("mingcute:user-add-line");
export const Users = bravosSvg("mingcute:group-2-line");
export const X = bravosSvg("mingcute:close-line");
export const XCircle = bravosSvg("mingcute:close-circle-line");
